/* unplugin-vue-components disabled */import { render } from "./ScenicFoodInfoCard.vue?vue&type=template&id=54fb86c5&ts=true"
import script from "./ScenicFoodInfoCard.vue?vue&type=script&lang=ts"
export * from "./ScenicFoodInfoCard.vue?vue&type=script&lang=ts"

import "./ScenicFoodInfoCard.vue?vue&type=style&index=0&id=54fb86c5&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__